angular
  .module("admin")
  .controller(
    "ChangePasswordCtrl",
    function ($uibModalInstance, SupervisorResource) {
      this.form = {
        newPassword: "",
        confirmPassword: "",
      };

      this.dismiss = function () {
        $uibModalInstance.close();
      };

      this.change = function (frm) {
        this.submited = true;
        this.alerts = [];
        if (frm.$invalid) return;

        const payload = {
          password: this.form.newPassword,
          oldPassword: this.form.oldPassword,
        };

        SupervisorResource.changePassword(
          payload,
          () => {
            this.form = {
              newPassword: "",
              confirmPassword: "",
              oldPassword: "",
            };
            this.submited = false;
            frm.$setPristine();
            frm.$setUntouched();
            
            this.alerts = [
              {
                message: "Senha alterada com sucesso! A nova senha foi registrada.",
                type: "success",
              },
            ];
          },
          (err) => {
            this.alerts = [
              {
                message: err.data.message || "Erro ao alterar senha",
                type: "danger",
              },
            ];
          }
        );
      };
    }
  );
